{
  "name": "@thecvlb/care-patient-portal-web",
  "version": "80.0.0",
  "private": true,
  "type": "module",
  "engines": {
    "node": ">=24.20.0 <25.0.0"
  },
  "dependencies": {
    "@convex-dev/persistent-text-streaming": "^0.3.3",
    "@culturehq/add-to-calendar": "^1.1.2",
    "@datadog/browser-logs": "^7.11.0",
    "@datadog/browser-rum": "^7.11.0",
    "@everflow/everflow-sdk": "^1.6.0",
    "@googlemaps/react-wrapper": "^1.2.0",
    "@headlessui/react": "^2.2.10",
    "@mona-health/react-input-mask": "^3.0.3",
    "@reduxjs/toolkit": "^2.12.0",
    "@tailwindcss/forms": "^0.5.11",
    "@thecvlb/design-system": "^1.288.0",
    "@unleash/proxy-client-react": "^6.0.1",
    "@zoom/videosdk": "2.4.7",
    "browser-image-compression": "^2.0.2",
    "chart.js": "^4.5.1",
    "classnames": "^2.5.1",
    "convex": "^1.45.0",
    "dayjs": "^1.11.23",
    "firebase": "^12.18.0",
    "framer-motion": "^12.43.0",
    "heic2any": "^0.0.4",
    "html-react-parser": "^6.1.7",
    "i18next": "^26.4.1",
    "i18next-browser-languagedetector": "^8.2.1",
    "js-cookie": "^3.0.8",
    "js-file-download": "^0.4.12",
    "jsonwebtoken": "^9.0.3",
    "jwt-decode": "^4.0.0",
    "lottie-react": "^2.4.2",
    "nanoid": "^6.0.1",
    "posthog-js": "^1.425.1",
    "react": "^19.2.8",
    "react-countdown": "^2.3.6",
    "react-day-picker": "^10.0.1",
    "react-device-detect": "^2.2.3",
    "react-dom": "^19.2.8",
    "react-draggable": "^4.7.1",
    "react-error-boundary": "^6.1.4",
    "react-fast-marquee": "^1.6.5",
    "react-gtm-module": "^2.0.11",
    "react-hook-form": "^7.87.0",
    "react-horizontal-scrolling-menu": "^8.3.2",
    "react-i18next": "^17.0.13",
    "react-idle-timer": "^5.7.3",
    "react-loading-skeleton": "^3.5.0",
    "react-medium-image-zoom": "^5.4.9",
    "react-paginate": "^8.3.0",
    "react-phone-number-input": "^3.4.18",
    "react-player": "^3.4.0",
    "react-qr-code": "^2.2.0",
    "react-range": "^1.10.0",
    "react-redux": "^9.3.0",
    "react-responsive-carousel": "^3.2.23",
    "react-router-dom": "^7.18.3",
    "react-simple-star-rating": "^5.1.7",
    "react-sliding-pane": "^7.3.0",
    "react-toastify": "^11.1.0",
    "react-tooltip": "^6.0.8",
    "react-use": "^17.6.1",
    "redux": "^5.0.1",
    "redux-persist": "^6.0.0",
    "socket.io-client": "^4.8.3",
    "unleash-proxy-client": "^3.8.2",
    "use-deep-compare-effect": "^1.8.1"
  },
  "scripts": {
    "start": "node ./scripts/setup/start-dev.mjs",
    "convex:dev": "node ./scripts/setup/run-convex-dev.mjs",
    "vite:dev": "vite",
    "generate:headers": "tsx src/scripts/generateHeaders.ts",
    "setup:env-local": "node ./scripts/setup/copy-local-env.mjs",
    "build": "yarn generate:headers && tsc && cross-env NODE_OPTIONS=--max-old-space-size=8192 vite build",
    "serve": "vite preview",
    "report": "vite build --stats",
    "analyze": "vite-bundle-visualizer",
    "test": "vitest",
    "test:no-watch": "vitest run",
    "test:coverage": "vitest run --coverage",
    "eject": "vitest eject",
    "lint": "yarn run lint:check --fix",
    "lint:check": "eslint .",
    "cs": "prettier --write .",
    "cs:check": "prettier --check .",
    "prepare": "husky",
    "knip": "knip",
    "build:document-css": "tsx src/scripts/buildDocumentCss.ts"
  },
  "lint-staged": {
    "*.{js,ts,tsx}": [
      "prettier --write",
      "eslint --fix"
    ]
  },
  "eslintConfig": {
    "extends": [
      "react-app"
    ]
  },
  "resolutions": {
    "mux-embed@workspace:*": "npm:5.17.4"
  },
  "browserslist": {
    "production": [
      ">0.2%",
      "not dead",
      "not op_mini all"
    ],
    "development": [
      "last 1 chrome version",
      "last 1 firefox version",
      "last 1 safari version"
    ]
  },
  "devDependencies": {
    "@commitlint/cli": "^21.2.2",
    "@commitlint/config-conventional": "^21.2.2",
    "@hookform/devtools": "^4.4.0",
    "@tailwindcss/node": "^4.3.3",
    "@tailwindcss/postcss": "^4.3.3",
    "@tailwindcss/vite": "^4.3.3",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/jest-dom": "^7.0.1",
    "@testing-library/react": "^16.3.3",
    "@testing-library/user-event": "^14.6.7",
    "@types/google.maps": "^3.66.1",
    "@types/jsonwebtoken": "^9.0.10",
    "@types/lodash": "^4.17.25",
    "@types/node": "^26.4.1",
    "@types/react": "^19.2.18",
    "@types/react-dom": "^19.2.5",
    "@types/react-gtm-module": "^2.0.4",
    "@typescript-eslint/eslint-plugin": "^8.69.0",
    "@typescript-eslint/parser": "^8.69.0",
    "@vitejs/plugin-react": "^6.1.1",
    "@vitest/coverage-v8": "^4.1.11",
    "autoprefixer": "^10.5.4",
    "baseline-browser-mapping": "^2.11.20",
    "branch-name-lint": "^3.0.1",
    "cross-env": "^10.1.0",
    "cross-fetch": "^4.1.0",
    "eslint": "^10.9.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-config-react-app": "^7.0.1",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-perfectionist": "^5.11.0",
    "eslint-plugin-prettier": "^5.5.6",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-tailwindcss": "^4.4.0",
    "eslint-plugin-testing-library": "^7.16.2",
    "husky": "^9.1.7",
    "jsdom": "^30.0.1",
    "knip": "^6.34.0",
    "lint-staged": "^17.4.1",
    "lodash": "^4.18.1",
    "mock-local-storage": "^1.1.24",
    "msw": "^2.15.0",
    "postcss": "^8.5.26",
    "prettier": "^3.9.6",
    "tailwind-merge": "^3.6.0",
    "tailwindcss": "^4.3.3",
    "tsx": "^4.23.13",
    "typescript": "^6.0.3",
    "vite": "^8.2.2",
    "vite-bundle-visualizer": "^1.2.1",
    "vite-plugin-html-config": "^2.0.2",
    "vite-plugin-svgr": "^5.2.0",
    "vite-tsconfig-paths": "^6.1.1",
    "vitest": "^4.1.11",
    "vitest-canvas-mock": "^1.1.5"
  },
  "packageManager": "yarn@4.12.0",
  "msw": {
    "workerDirectory": [
      "public"
    ]
  }
}
